/**
 * The remembered answer to the same-workspace Add from workspace chooser:
 * once set, picks skip the dialog and always land as live references (the
 * routine verb — copies stay reachable via Copy to / paste). Deliberately
 * scoped to the SAME-workspace dialog only: the cross-workspace fork keeps
 * asking, because its access caveat is load-bearing every time.
 *
 * Reset lives in Settings → Account, next to the theme.
 */

const STORAGE_KEY = "library-add-mode.always-reference";

export function alwaysAddAsReference(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function setAlwaysAddAsReference(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    // Storage unavailable — the dialog simply keeps asking.
  }
}

export function resetAlwaysAddAsReference(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing stored to clear.
  }
}
